import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { useContent } from "../lib/content";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function TransitInfo({ items }) {
  const { t } = useContent();
  const [open, setOpen] = useState(false);
  if (!items?.length) return null;

  return (
    <div data-testid="transit-info" className="border border-[#C9A25E]/25 bg-[#C9A25E]/[0.03] mb-10">
      <button data-testid="transit-info-toggle" onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between px-6 py-4 text-left text-[#C9A25E] hover:text-white transition-colors">
        <span className="font-display text-xl">{t("plat_transits_info_label", "¿Qué significa?")}</span>
        <ChevronDown size={18} className={`transition-transform duration-300 ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div data-testid="transit-info-content" className="px-6 pb-8 space-y-10">
          {items.map((it) => (
            <div key={it.id} className={`grid gap-6 items-start ${it.image_url ? "md:grid-cols-[1fr_2fr]" : ""}`}>
              {it.image_url && <img src={`${BACKEND_URL}${it.image_url}`} alt={it.title} className="w-full border border-white/10" />}
              <div>
                <h3 className="font-display text-2xl text-white mb-3">{it.title}</h3>
                <p className="text-zinc-400 leading-relaxed whitespace-pre-wrap">{it.text}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
